import React from 'react';
import { Box, Card } from "@mui/material";
import Slider from "react-slick";

const _DashSlider = () => {
    const settings = {
        centerMode: false,
        infinite: true,
        slidesToShow: 1,
        dots: true,
        arrows: false,
        rtl: true,
        autoplay: true,
        speed: 800,
        autoplaySpeed: 4500,
        pauseOnHover: true,
    };

    function SliderItem({ image, alt, onClick }) {
        return (
            <Box
                onClick={onClick}
                sx={{
                    width: '100%',
                    cursor: onClick ? 'pointer' : 'default',
                    outline: 'none',
                    lineHeight: 0,
                    display: 'block',
                }}
            >
                <Card
                    elevation={0}
                    sx={{
                        borderRadius: { xs: 3, md: 4 },
                        overflow: 'hidden',
                        border: '1px solid',
                        borderColor: 'divider',
                        boxShadow: '0 4px 20px rgba(0, 0, 0, 0.04)',
                        position: 'relative',
                        width: '100%',
                        height: { xs: 180, sm: 260, md: 330, lg: 370 },
                        bgcolor: 'background.paper',
                    }}
                >
                    <Box
                        component="img"
                        alt={alt}
                        src={image}
                        sx={{
                            width: '100% !important',
                            height: '100% !important',
                            objectFit: 'cover !important',
                            display: 'block !important',
                        }}
                    />
                </Card>
            </Box>
        );
    }

    return (
        <Box
            className="dash-slider"
            sx={{
                width: '100%',
                overflow: 'hidden',
                borderRadius: { xs: 3, md: 4 },
                '& .slick-slider': {
                    width: '100%',
                },
                '& .slick-list': {
                    borderRadius: { xs: 3, md: 4 },
                    overflow: 'hidden',
                },
                '& .slick-slide': {
                    outline: 'none',
                    '& > div': {
                        width: '100%',
                    },
                    '& img': {
                        width: '100% !important',
                        height: '100% !important',
                        objectFit: 'cover !important',
                        display: 'block !important',
                    }
                },
                '& .slick-dots': {
                    bottom: 12,
                    zIndex: 2,
                    '& li': {
                        margin: '0 3px',
                        '& button:before': {
                            fontSize: 8,
                            color: '#ffffff',
                            opacity: 0.6,
                        },
                        '&.slick-active button:before': {
                            color: '#ffffff',
                            opacity: 1,
                            fontSize: 10,
                        }
                    }
                }
            }}
        >
            <Slider {...settings}>
                <SliderItem
                    image="/assets/images/slide1.jpg"
                    alt="سامانه جامع خدمات رفاهی ورزشی جیم‌پین"
                />
                <SliderItem
                    image="/assets/images/slide2.jpg"
                    alt="تجربه جدید خدمات ورزشی"
                />
                <SliderItem
                    image="/assets/images/slide3.jpg"
                    alt="اعتبار دهی هوشمند به کارمندان"
                />
            </Slider>
        </Box>
    );
};

export default _DashSlider;
